function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { CheckBox, TextInput, ThemeContext } from 'grommet';

// Core Imports
import DatePicker from 'granite-admin/core/components/DatePicker';
import DateRangeOptions from 'granite-admin/core/components/DatePicker/DateRangeOptions';
import MultiSelect from 'granite-admin/core/components/MultiSelect';
import PasswordInput from 'granite-admin/core/components/PasswordInput';
import Select from 'granite-admin/core/components/Select';
import Autocomplete from 'granite-admin/core/components/Autocomplete/index.js';
import CustomSelector from 'granite-admin/core/components/CustomSelector';
import ConfigField from 'granite-admin/core/components/ConfigField';
import AsyncSelect from 'granite-admin/core/components/AsyncSelect';
import FormField from 'granite-admin/core/components/FormField';
import MultiSelectTextInput from 'granite-admin/core/components/MultiSelectTextInput';
import RangeSelector from 'granite-admin/core/components/RangeSelector';
const Items = ({
  item,
  value: val,
  setFieldValue,
  config,
  eventEmitter,
  setFieldError,
  errors,
  showFilterLabel
}) => {
  const theme = useContext(ThemeContext);
  const {
    components: {
      Datepicker
    } = {}
  } = theme.filter ?? {};
  const handleOnChange = value => {
    if (value === true || value === false || value?.length > 0 || typeof value === 'number') setFieldValue(item.name, value);else setFieldValue(item.name);
  };
  if (item.type === 'select') {
    const {
      value,
      ...rest
    } = item;
    return /*#__PURE__*/React.createElement(FormField, {
      name: item.name,
      label: showFilterLabel && item.label
    }, /*#__PURE__*/React.createElement(Select, _extends({
      name: item.name,
      value: value?.[item.name]?.[item.valueKey] || val,
      options: item.options,
      onChange: ({
        value
      }) => handleOnChange(value?.[item.valueKey] || value),
      disabled: item.disabled,
      menuPortalTarget: document.body
    }, rest)));
  } else if (item.type === 'text') {
    return /*#__PURE__*/React.createElement(FormField, {
      name: item.name,
      label: showFilterLabel && item.label
    }, /*#__PURE__*/React.createElement(TextInput, {
      type: "text",
      name: item.name,
      disabled: item.disabled,
      onChange: e => handleOnChange(e.target.value),
      value: val || ''
    }));
  } else if (item.type === 'password') {
    return /*#__PURE__*/React.createElement(FormField, {
      name: item.name,
      label: showFilterLabel && item.label
    }, /*#__PURE__*/React.createElement(PasswordInput, {
      name: item.name,
      onChange: e => handleOnChange(e.target.value),
      value: val,
      disabled: item.disabled,
      type: "password"
    }));
  } else if (item.type === 'date') {
    return /*#__PURE__*/React.createElement(FormField, {
      name: item.name,
      label: showFilterLabel && item.label,
      error: errors?.[item.name]
    }, Datepicker ? /*#__PURE__*/React.createElement(Datepicker, {
      name: item.name,
      initialDate: val,
      onChange: handleOnChange,
      customFormat: item.customFormat,
      viewDateFormat: item?.viewDateFormat,
      disableInput: item?.disableInput
    }) : /*#__PURE__*/React.createElement(DatePicker, {
      name: item.name,
      initialDate: val,
      onChange: handleOnChange,
      customFormat: item.customFormat,
      viewDateFormat: item?.viewDateFormat,
      disableInput: item?.disableInput
    }));
  } else if (item.type === 'date_range') {
    return /*#__PURE__*/React.createElement(DateRangeOptions, {
      name: item.name,
      label: showFilterLabel && item.label,
      initialDate: val,
      onChange: value => handleOnChange(value ? value.sDate + ' - ' + value.eDate : value),
      customFormat: item.customFormat,
      viewDateFormat: item?.viewDateFormat,
      menuPortalTarget: document.body,
      getDateRangeOptions: item.getDateRangeOptions,
      boundDays: item.boundDays
    });
  } else if (item.type === 'multi_select') {
    let valArr = val ? JSON.parse(val) : [];
    let vK = item.valueKey?.key || item.valueKey;
    let defaultSelectedOptions;
    if (item.options && item.options[0]) {
      if (typeof item.options[0] === 'object') {
        defaultSelectedOptions = item.options.filter(x => valArr?.includes(x[vK]));
      } else if (item.options[0] === 'string') {
        defaultSelectedOptions = valArr;
      }
    }
    return /*#__PURE__*/React.createElement(FormField, {
      name: item.name,
      label: showFilterLabel && item.label
    }, /*#__PURE__*/React.createElement(MultiSelect, {
      labelKey: item.labelKey,
      valueKey: item.valueKey,
      defaultSelectedOptions: defaultSelectedOptions,
      options: item.options,
      onChange: data => {
        handleOnChange(JSON.stringify(data.map(i => i[vK])));
      },
      disabled: item.disabled,
      menuPortalTarget: document.body
    }));
  } else if (item.type === 'multiSelectTextInput') {
    let valArr = val ? JSON.parse(val) : [];
    let defaultOptions = valArr.map(val => ({
      label: val,
      value: val
    }));
    return /*#__PURE__*/React.createElement(FormField, {
      name: item.name,
      label: showFilterLabel && item.label,
      error: errors?.[item.name]
    }, /*#__PURE__*/React.createElement(MultiSelectTextInput, {
      name: item.name,
      onChange: newValue => {
        handleOnChange(JSON.stringify(newValue.map(val => typeof val === 'object' ? val.value : val)));
      },
      defaultOptions: defaultOptions,
      defaultSelectedOptions: defaultOptions,
      setFieldError: setFieldError
    }));
  } else if (item.type === 'checkbox') {
    return /*#__PURE__*/React.createElement(FormField, {
      name: item.name,
      label: showFilterLabel && item.label
    }, /*#__PURE__*/React.createElement(CheckBox, {
      name: item.name,
      label: showFilterLabel && item.label,
      disabled: item.disabled,
      onChange: e => handleOnChange(e.target.checked),
      checked: val
    }));
  } else if (item.type === 'autocomplete') {
    const {
      value,
      ...rest
    } = item;
    return /*#__PURE__*/React.createElement(FormField, {
      name: item.name,
      label: showFilterLabel && item.label
    }, /*#__PURE__*/React.createElement(Autocomplete, _extends({}, rest, {
      fetchData: item.fetch,
      labelKey: item.labelKey,
      defaultSelected: val,
      onChange: selectedValues => {
        handleOnChange(selectedValues.map(e => e[item.valueKey]));
      }
    })));
  } else if (item.type === 'config-master') {
    return /*#__PURE__*/React.createElement(FormField, {
      name: item.name,
      label: showFilterLabel && item.label.capitalize()
    }, /*#__PURE__*/React.createElement(ConfigField, {
      fieldName: item.name,
      name: item.label,
      value: val,
      onChange: value => {
        value = item.type === 'multitextselect' || item.overrideType === 'multitextselect' ? value.length > 0 ? JSON.stringify(value) : [] : value;
        handleOnChange(value);
      },
      entityName: item?.extra_data?.entity_name,
      submenuOverlay: document.body,
      configData: config.find(x => x.name === item.name && x.type === 'config-master'),
      overrideType: item.overrideType,
      eventEmitter: eventEmitter
    }));
  } else if (item.type === 'customSelector') {
    const {
      value,
      ...rest
    } = item;
    return /*#__PURE__*/React.createElement(FormField, {
      name: item.name,
      label: showFilterLabel && item.label
    }, /*#__PURE__*/React.createElement(CustomSelector, _extends({
      onChange: handleOnChange,
      value: val,
      menuPortalTarget: document.body
    }, rest)));
  } else if (item.type === 'async-select') {
    let valArr;
    if (item.isMulti) valArr = val ? JSON.parse(val) : [];
    return /*#__PURE__*/React.createElement(FormField, {
      name: item.name,
      label: showFilterLabel && item.label
    }, /*#__PURE__*/React.createElement(AsyncSelect, {
      fetch: item.fetch,
      onChange: value => handleOnChange(item.isMulti === true ? value.length > 0 ? JSON.stringify(value) : [] : value),
      value: item.isMulti ? valArr : val,
      labelKey: item.labelKey,
      valueKey: item.valueKey,
      queryParams: item.queryParams,
      isMulti: item.isMulti,
      closeMenuOnSelect: !item.isMulti,
      name: item.name,
      defaultOptions: Array.isArray(item.options) ? item.options : true,
      submenuOverlay: document.body,
      configData: config.find(x => x.name === item.name && x.type === 'async-select'),
      eventEmitter: eventEmitter,
      dataSource: item?.dataSource,
      searchKey: item.searchKey ?? 'search',
      extraData: item?.extraData
    }));
  } else if (item.type === 'range') {
    return /*#__PURE__*/React.createElement(FormField, {
      name: item.name,
      label: showFilterLabel && item.label
    }, /*#__PURE__*/React.createElement(RangeSelector, {
      direction: item.direction,
      options: item.options,
      value: val || [item.options[0]],
      handleOnChange: handleOnChange
    }));
  } else return null;
};
Items.propTypes = {
  item: PropTypes.object,
  values: PropTypes.object,
  setFieldValue: PropTypes.func,
  errors: PropTypes.object,
  setFieldError: PropTypes.func,
  showFilterLabel: PropTypes.bool
};
export default Items;